function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('../../lib/saito/saito');
var Transaction = require('../../lib/saito/transaction')["default"];
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoPhotoUploader = require('../../lib/saito/ui/saito-photo-uploader/saito-photo-uploader');
var UpdateDescription = require('./lib/ui/update-description');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var SaitoProfile = require('../../lib/saito/ui/saito-profile/saito-profile');
var pageHome = require('./index');

// Keychain profile-index keys that are metadata, not archived tx signatures.
var PROFILE_INDEX_META_KEYS = new Set(['tx_sig', 'archive_nodes', 'archive']);
var Profile = /*#__PURE__*/function (_ModTemplate) {
  function Profile(app) {
    var _this;
    _classCallCheck(this, Profile);
    _this = _callSuper(this, Profile, [app]);
    _this.app = app;
    _this.name = 'Profile';
    _this.slug = 'profile';
    _this.description = 'Profile Module';
    _this.status = 'prod';
    _this["class"] = 'utility';
    _this.archive_public_key;

    // publicKey → complete profile object (authoritative local snapshot)
    _this.cache = {};
    // publicKey → true once we have attempted a full load into cache
    _this.profile_ready = {};
    // publicKey → in-flight ensureProfileLoaded promise
    _this.profile_loading = {};
    _this.enable_profile_edits = true;
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: '🟥 Saito User - Web3 Social Media',
      url: '/redsquare#profile',
      description: 'Peer to peer Web3 social media platform',
      image: 'https://saito.tech/wp-content/uploads/2022/04/saito_card.png' //square image with "Saito" below logo
    });
    app.connection.on('profile-fetch-content-and-update-dom', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(key) {
        var profile;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.info('profile-fetch-content-and-update-dom --- ' + key);
              _context.n = 1;
              return _this.ensureProfileLoaded(key);
            case 1:
              profile = _context.v;
              _this.app.connection.emit('profile-update-dom', key, profile);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    app.connection.on('profile-edit-banner', function (profile_key) {
      _this.photoUploader = new SaitoPhotoUploader(_this.app, _this.mod, 'banner');
      _this.photoUploader.callbackAfterUpload = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(photo) {
          var banner;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return _this.app.browser.resizeImg(photo);
              case 1:
                banner = _context2.v;
                _this.sendProfileTransaction({
                  banner: banner
                }, profile_key);
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }();
      _this.photoUploader.render(_this.photo);
    });
    app.connection.on('profile-edit-description', function (key) {
      var profile = _this.returnProfile(key);
      var description = typeof profile.description === 'string' ? profile.description : '';
      _this.updateDescription = new UpdateDescription(_this.app, _this, key);
      _this.updateDescription.render(description);
    });
    return _this;
  }
  _inherits(Profile, _ModTemplate);
  return _createClass(Profile, [{
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(blk, tx, conf) {
        var txmsg;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              txmsg = tx.returnMessage();
              if (!(Number(conf) == 0)) {
                _context3.n = 1;
                break;
              }
              if (!(txmsg.request === 'update profile')) {
                _context3.n = 1;
                break;
              }
              if (this.app.BROWSER) {
                console.debug('Profile onConfirmation');
              }
              _context3.n = 1;
              return this.receiveProfileTransaction(tx);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function onConfirmation(_x3, _x4, _x5) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, peer) {
        var service,
          keys_to_check,
          _iterator,
          _step,
          key,
          txs,
          profile,
          authoritative,
          newestFirst,
          txs_found,
          i,
          txmsg,
          field,
          _field,
          _args4 = arguments,
          _t,
          _t2,
          _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              service = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              if (app.BROWSER) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!(service.service === 'archive')) {
                _context4.n = 13;
                break;
              }
              keys_to_check = app.keychain.returnKeys({
                watched: true,
                profile: undefined
              });
              console.debug('PROFILE -- check friends keys in Archive!');
              _iterator = _createForOfIteratorHelper(keys_to_check);
              _context4.p = 2;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context4.n = 10;
                break;
              }
              key = _step.value;
              // Save an empty profile index so we don't keep querying on every page load.
              // Live updates still arrive via onConfirmation once we are watching them.
              app.keychain.addKey(key.publicKey, {
                profile: {}
              });
              _context4.n = 4;
              return this.loadProfileTransactions(key.publicKey, peer);
            case 4:
              txs = _context4.v;
              profile = this.buildProfileFromTransactions(txs);
              this.setCachedProfile(key.publicKey, profile);
              authoritative = this.selectAuthoritativeTransaction(txs);
              if (!authoritative) {
                _context4.n = 6;
                break;
              }
              _context4.n = 5;
              return this.receiveProfileTransaction(authoritative);
            case 5:
              _context4.n = 9;
              break;
            case 6:
              if (!(txs.length > 0)) {
                _context4.n = 9;
                break;
              }
              // Legacy incremental history: persist newest tx per field until a snapshot exists
              newestFirst = this.sortProfileTransactionsNewestFirst(txs);
              txs_found = {};
              for (i = newestFirst.length - 1; i >= 0; i--) {
                txmsg = newestFirst[i].returnMessage();
                for (field in (txmsg === null || txmsg === void 0 ? void 0 : txmsg.data) || {}) {
                  txs_found[field] = newestFirst[i];
                }
              }
              _t = _regeneratorKeys(txs_found);
            case 7:
              if ((_t2 = _t()).done) {
                _context4.n = 9;
                break;
              }
              _field = _t2.value;
              _context4.n = 8;
              return this.receiveProfileTransaction(txs_found[_field]);
            case 8:
              _context4.n = 7;
              break;
            case 9:
              _context4.n = 3;
              break;
            case 10:
              _context4.n = 12;
              break;
            case 11:
              _context4.p = 11;
              _t3 = _context4.v;
              _iterator.e(_t3);
            case 12:
              _context4.p = 12;
              _iterator.f();
              return _context4.f(12);
            case 13:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 11, 12, 13]]);
      }));
      function onPeerServiceUp(_x6, _x7) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var param, key, result, c;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              // Check for URL param (since that is the prime use case)
              param = this.app.browser.returnURLParameter('load_key');
              if (!param) {
                _context5.n = 3;
                break;
              }
              key = JSON.parse(this.app.crypto.base64ToString(param));
              if (!(key.publicKey !== this.publicKey)) {
                _context5.n = 3;
                break;
              }
              _context5.n = 1;
              return this.app.wallet.onUpgrade('import', key.privateKey);
            case 1:
              result = _context5.v;
              if (!result) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return sconfirm("Import key ".concat(this.app.keychain.returnUsername(key.publicKey), "?"));
            case 2:
              c = _context5.v;
              if (c) {
                reloadWindow(300);
              }
              return _context5.a(2);
            case 3:
              this.main = new SaitoProfile(this.app, this);
              this.header = new SaitoHeader(this.app, this);
              _context5.n = 4;
              return this.header.initialize(this.app);
            case 4:
              this.main.reset(this.publicKey);
              this.addComponent(this.main);
              this.addComponent(this.header);
              _context5.n = 5;
              return _superPropGet(Profile, "render", this, 3)([this.app, this]);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
    /**
     * Return the cached complete profile for a public key (may be empty).
     * Own wallet profile is sourced from app.options.profile when cache is cold.
     */
  }, {
    key: "returnProfile",
    value: function returnProfile() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var key = publicKey || this.publicKey;
      if (key === this.publicKey) {
        this.ensureOwnProfileCached();
      }
      return Object.assign({}, this.cache[key] || {});
    }

    /**
     * Seed cache for the local wallet from app.options.profile (no network I/O).
     */
  }, {
    key: "ensureOwnProfileCached",
    value: function ensureOwnProfileCached() {
      var _this$app$options;
      if (!this.publicKey) {
        return {};
      }
      if (this.profile_ready[this.publicKey] && this.cache[this.publicKey]) {
        return this.cache[this.publicKey];
      }
      var saved = (_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && _this$app$options.profile && _typeof(this.app.options.profile) === 'object' ? this.app.options.profile : {};
      return this.setCachedProfile(this.publicKey, saved);
    }

    /**
     * Persist the local wallet's complete profile into app.options.
     */
  }, {
    key: "saveOwnProfileOptions",
    value: function saveOwnProfileOptions() {
      var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.app.BROWSER) {
        return;
      }
      this.app.options.profile = Object.assign({}, profile || {});
      this.app.storage.saveOptions();
    }

    /**
     * Apply a partial update to the local profile object.
     * Pass null/undefined for a field to remove it (supports field deletion).
     *
     * @param {string} publicKey
     * @param {Object} data partial field updates
     * @returns {Object} complete profile after update
     */
  }, {
    key: "applyLocalProfileUpdate",
    value: function applyLocalProfileUpdate(publicKey) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (publicKey === this.publicKey) {
        this.ensureOwnProfileCached();
      } else if (!this.cache[publicKey]) {
        this.cache[publicKey] = {};
      }
      for (var _i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
        var field = _Object$keys[_i];
        var value = data[field];
        if (value === null || typeof value === 'undefined') {
          delete this.cache[publicKey][field];
        } else {
          this.cache[publicKey][field] = value;
        }
      }
      this.profile_ready[publicKey] = true;
      if (publicKey === this.publicKey) {
        this.saveOwnProfileOptions(this.cache[publicKey]);
      }
      return this.cache[publicKey];
    }
  }, {
    key: "setCachedProfile",
    value: function setCachedProfile(publicKey) {
      var profile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.cache[publicKey] = Object.assign({}, profile || {});
      this.profile_ready[publicKey] = true;
      if (publicKey === this.publicKey && this.app.BROWSER) {
        this.saveOwnProfileOptions(this.cache[publicKey]);
      }
      return this.cache[publicKey];
    }

    /**
     * Load a profile into cache when the UI asks for it.
     * Own wallet uses app.options only — never blocks on network during init/send.
     */
  }, {
    key: "ensureProfileLoaded",
    value: function () {
      var _ensureProfileLoaded = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(publicKey) {
        var _this2 = this;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (publicKey) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, {});
            case 1:
              if (!(publicKey === this.publicKey)) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2, this.ensureOwnProfileCached());
            case 2:
              if (!this.profile_ready[publicKey]) {
                _context7.n = 3;
                break;
              }
              if (!this.cache[publicKey]) {
                this.cache[publicKey] = {};
              }
              return _context7.a(2, this.cache[publicKey]);
            case 3:
              if (this.app.BROWSER) {
                _context7.n = 4;
                break;
              }
              return _context7.a(2, this.setCachedProfile(publicKey, {}));
            case 4:
              if (!this.profile_loading[publicKey]) {
                _context7.n = 5;
                break;
              }
              return _context7.a(2, this.profile_loading[publicKey]);
            case 5:
              this.profile_loading[publicKey] = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
                var profile, returned_key, txs;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      profile = null;
                      if (!_this2.app.keychain.isWatched(publicKey)) {
                        _context6.n = 2;
                        break;
                      }
                      returned_key = _this2.app.keychain.returnKey(publicKey);
                      if (!(returned_key !== null && returned_key !== void 0 && returned_key.profile)) {
                        _context6.n = 2;
                        break;
                      }
                      _context6.n = 1;
                      return _this2.fetchProfileFromArchive(returned_key);
                    case 1:
                      profile = _context6.v;
                    case 2:
                      if (!(profile === null)) {
                        _context6.n = 4;
                        break;
                      }
                      _context6.n = 3;
                      return _this2.loadProfileTransactions(publicKey, null);
                    case 3:
                      txs = _context6.v;
                      profile = _this2.buildProfileFromTransactions(txs);
                    case 4:
                      return _context6.a(2, _this2.setCachedProfile(publicKey, profile || {}));
                  }
                }, _callee6);
              }))();
              _context7.p = 6;
              _context7.n = 7;
              return this.profile_loading[publicKey];
            case 7:
              return _context7.a(2, _context7.v);
            case 8:
              _context7.p = 8;
              delete this.profile_loading[publicKey];
              return _context7.f(8);
            case 9:
              return _context7.a(2);
          }
        }, _callee7, this, [[6,, 8, 9]]);
      }));
      function ensureProfileLoaded(_x8) {
        return _ensureProfileLoaded.apply(this, arguments);
      }
      return ensureProfileLoaded;
    }()
  }, {
    key: "loadProfileTransactions",
    value: function loadProfileTransactions(publicKey) {
      var _this3 = this;
      var peer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return new Promise(function (resolve) {
        _this3.app.storage.loadTransactions(
        // limit 100: enough legacy incremental history for migration;
        // snapshot-era profiles only need the newest tx.
        {
          field1: 'Profile',
          field2: publicKey,
          limit: 100
        }, function (txs) {
          return resolve(txs || []);
        }, peer);
      });
    }

    /**
     * Reconstruct profile content from archived txs.
     *
     * New snapshot txs (msg.snapshot) are authoritative — newest wins.
     * Legacy incremental txs are merged oldest → newest for migration.
     */
  }, {
    key: "buildProfileFromTransactions",
    value: function buildProfileFromTransactions() {
      var txs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!(txs !== null && txs !== void 0 && txs.length)) {
        return {};
      }
      var newestFirst = this.sortProfileTransactionsNewestFirst(txs);
      for (var i = 0; i < newestFirst.length; i++) {
        var txmsg = newestFirst[i].returnMessage();
        if (this.isSnapshotMessage(txmsg)) {
          return Object.assign({}, txmsg.data || {});
        }
      }

      // Legacy incremental history: merge oldest → newest
      var data = {};
      for (var _i2 = newestFirst.length - 1; _i2 >= 0; _i2--) {
        var _txmsg = newestFirst[_i2].returnMessage();
        if (_txmsg !== null && _txmsg !== void 0 && _txmsg.data) {
          Object.assign(data, _txmsg.data);
        }
      }
      return data;
    }

    /**
     * Newest snapshot tx if any; otherwise null (legacy-only history).
     */
  }, {
    key: "selectAuthoritativeTransaction",
    value: function selectAuthoritativeTransaction() {
      var txs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!(txs !== null && txs !== void 0 && txs.length)) {
        return null;
      }
      var newestFirst = this.sortProfileTransactionsNewestFirst(txs);
      for (var i = 0; i < newestFirst.length; i++) {
        var txmsg = newestFirst[i].returnMessage();
        if (this.isSnapshotMessage(txmsg)) {
          return newestFirst[i];
        }
      }
      return null;
    }
  }, {
    key: "isSnapshotMessage",
    value: function isSnapshotMessage(txmsg) {
      return Boolean(txmsg && (txmsg.snapshot === 1 || txmsg.snapshot === true));
    }
  }, {
    key: "sortProfileTransactionsNewestFirst",
    value: function sortProfileTransactionsNewestFirst() {
      var txs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return txs.slice().sort(function (a, b) {
        var ta = Number(a === null || a === void 0 ? void 0 : a.timestamp) || 0;
        var tb = Number(b === null || b === void 0 ? void 0 : b.timestamp) || 0;
        return tb - ta;
      });
    }

    /**
     * Update profile fields and broadcast a complete snapshot transaction.
     *
     * Callers may pass a partial update (e.g. `{ description }`). The module
     * merges that into the local complete profile, then serializes the full
     * object. Pass `null`/`undefined` for a field to remove it.
     *
     * @param {Object} data partial update { image, banner, description, archive, ... }
     **/
  }, {
    key: "sendProfileTransaction",
    value: function () {
      var _sendProfileTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var data,
          snapshot,
          newtx,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              data = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
              // Own profile is local state (app.options.profile) — do not await network I/O.
              snapshot = Object.assign({}, this.applyLocalProfileUpdate(this.publicKey, data));
              this.app.connection.emit('saito-header-update-message', {
                msg: 'broadcasting profile update'
              });
              _context8.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.publicKey);
            case 1:
              newtx = _context8.v;
              newtx.msg = {
                module: this.name,
                request: 'update profile',
                snapshot: 1,
                data: snapshot
              };
              _context8.n = 2;
              return newtx.sign();
            case 2:
              this.app.connection.emit('profile-update-dom', this.publicKey, snapshot);
              _context8.n = 3;
              return this.app.network.propagateTransaction(newtx);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function sendProfileTransaction() {
        return _sendProfileTransaction.apply(this, arguments);
      }
      return sendProfileTransaction;
    }()
    /**
     * Optional capability for other modules (e.g. Store) to update own Profile
     * without importing this module. Blank/null field values remove the field.
     */
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this4 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (type === 'profile-update') {
        return {
          get: function get() {
            var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            return _this4.returnProfile(publicKey || _this4.publicKey);
          },
          update: function () {
            var _update = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
              var data,
                _args9 = arguments;
              return _regenerator().w(function (_context9) {
                while (1) switch (_context9.n) {
                  case 0:
                    data = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
                    return _context9.a(2, _this4.applyProfileUpdateRequest(data));
                }
              }, _callee9);
            }));
            function update() {
              return _update.apply(this, arguments);
            }
            return update;
          }()
        };
      }
      return null;
    }

    /**
     * Merge a partial profile update and broadcast only when something changes.
     * Empty string / null / undefined for a field removes it from the snapshot.
     */
  }, {
    key: "applyProfileUpdateRequest",
    value: function () {
      var _applyProfileUpdateRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var data,
          patch,
          has_keys,
          _i3,
          _Object$entries,
          _Object$entries$_i,
          key,
          value,
          blank,
          current,
          changed,
          _i4,
          _Object$entries2,
          _Object$entries2$_i,
          _key,
          next,
          cur_raw,
          cur,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              data = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : {};
              if (!(!data || _typeof(data) !== 'object')) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2, this.returnProfile(this.publicKey));
            case 1:
              patch = {};
              has_keys = false;
              for (_i3 = 0, _Object$entries = Object.entries(data); _i3 < _Object$entries.length; _i3++) {
                _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                has_keys = true;
                blank = value == null || String(value).trim() === '';
                patch[key] = blank ? null : String(value).trim();
              }
              if (has_keys) {
                _context0.n = 2;
                break;
              }
              return _context0.a(2, this.returnProfile(this.publicKey));
            case 2:
              current = this.returnProfile(this.publicKey);
              changed = false;
              _i4 = 0, _Object$entries2 = Object.entries(patch);
            case 3:
              if (!(_i4 < _Object$entries2.length)) {
                _context0.n = 5;
                break;
              }
              _Object$entries2$_i = _slicedToArray(_Object$entries2[_i4], 2), _key = _Object$entries2$_i[0], next = _Object$entries2$_i[1];
              cur_raw = current[_key];
              cur = cur_raw == null || String(cur_raw).trim() === '' ? null : String(cur_raw).trim();
              if (!(cur !== next)) {
                _context0.n = 4;
                break;
              }
              changed = true;
              return _context0.a(3, 5);
            case 4:
              _i4++;
              _context0.n = 3;
              break;
            case 5:
              if (changed) {
                _context0.n = 6;
                break;
              }
              return _context0.a(2, current);
            case 6:
              _context0.n = 7;
              return this.sendProfileTransaction(patch);
            case 7:
              return _context0.a(2, this.returnProfile(this.publicKey));
          }
        }, _callee0, this);
      }));
      function applyProfileUpdateRequest() {
        return _applyProfileUpdateRequest.apply(this, arguments);
      }
      return applyProfileUpdateRequest;
    }()
    /**
     * Processes a received transaction to update a user's profile.
     *
     * Snapshot txs replace the cached profile entirely.
     * Legacy incremental txs merge into cache (migration / in-flight old peers).
     *
     * @param {Object} tx - The transaction object received, containing data to be processed.
     **/
  }, {
    key: "receiveProfileTransaction",
    value: function () {
      var _receiveProfileTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(tx) {
        var _tx$from$;
        var from, txmsg, incoming, returned_key, previous_index, profile_index, _i5, _Object$keys2, field, prior, _profile_index, _i6, _Object$keys3, _field2;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              from = tx === null || tx === void 0 || (_tx$from$ = tx.from[0]) === null || _tx$from$ === void 0 ? void 0 : _tx$from$.publicKey;
              if (from) {
                _context1.n = 1;
                break;
              }
              console.error('Profile: Invalid TX');
              return _context1.a(2);
            case 1:
              txmsg = tx.returnMessage();
              incoming = txmsg !== null && txmsg !== void 0 && txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              if (this.isSnapshotMessage(txmsg)) {
                this.setCachedProfile(from, incoming);
              } else {
                // Legacy incremental update — merge until that user publishes a snapshot
                if (from === this.publicKey) {
                  this.ensureOwnProfileCached();
                } else if (!this.cache[from]) {
                  this.cache[from] = {};
                }
                Object.assign(this.cache[from], incoming);
                this.profile_ready[from] = true;
                if (from === this.publicKey) {
                  this.saveOwnProfileOptions(this.cache[from]);
                }
              }
              if (!(this.app.BROWSER && this.app.keychain.isWatched(from))) {
                _context1.n = 9;
                break;
              }
              returned_key = this.app.keychain.returnKey(from);
              previous_index = Object.assign({}, (returned_key === null || returned_key === void 0 ? void 0 : returned_key.profile) || {});
              if (!this.isSnapshotMessage(txmsg)) {
                _context1.n = 3;
                break;
              }
              _context1.n = 2;
              return this.deleteIndexedProfileTransactions(previous_index);
            case 2:
              profile_index = {
                tx_sig: tx.signature
              };
              if (previous_index.archive_nodes) {
                profile_index.archive_nodes = previous_index.archive_nodes;
              }
              this.app.keychain.addKey(from, {
                profile: profile_index
              });
              _context1.n = 7;
              break;
            case 3:
              _i5 = 0, _Object$keys2 = Object.keys(incoming);
            case 4:
              if (!(_i5 < _Object$keys2.length)) {
                _context1.n = 6;
                break;
              }
              field = _Object$keys2[_i5];
              prior = previous_index[field];
              if (!(typeof prior === 'string' && prior)) {
                _context1.n = 5;
                break;
              }
              _context1.n = 5;
              return this.app.storage.deleteTransaction(prior, '', 'localhost');
            case 5:
              _i5++;
              _context1.n = 4;
              break;
            case 6:
              _profile_index = Object.assign({}, previous_index);
              for (_i6 = 0, _Object$keys3 = Object.keys(incoming); _i6 < _Object$keys3.length; _i6++) {
                _field2 = _Object$keys3[_i6];
                if (_field2 === 'archive') {
                  _profile_index[_field2] = incoming[_field2];
                } else {
                  _profile_index[_field2] = tx.signature;
                }
              }
              delete _profile_index.tx_sig;
              this.app.keychain.addKey(from, {
                profile: _profile_index
              });
            case 7:
              _context1.n = 8;
              return this.saveProfileTransaction(tx);
            case 8:
              _context1.n = 10;
              break;
            case 9:
              if (this.app.BROWSER) {
                _context1.n = 10;
                break;
              }
              _context1.n = 10;
              return this.saveProfileTransaction(tx);
            case 10:
              if (tx.isFrom(this.publicKey)) {
                this.app.connection.emit('saito-header-update-message', {
                  msg: ''
                });
                siteMessage('Profile updated', 2000);
              }
              if (this.app.keychain.isWatched(from)) {
                this.app.connection.emit('profile-update-dom', from, this.cache[from]);
              }
            case 11:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function receiveProfileTransaction(_x9) {
        return _receiveProfileTransaction.apply(this, arguments);
      }
      return receiveProfileTransaction;
    }()
    /**
     * Load profile content for a watched key from the local archive.
     * Uses newest snapshot when present; otherwise merges legacy incremental txs.
     */
  }, {
    key: "fetchProfileFromArchive",
    value: function () {
      var _fetchProfileFromArchive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(key) {
        var _this5 = this;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              console.info('PROFILE: Fetching local profile for: ', key);
              return _context10.a(2, this.app.storage.loadTransactions({
                field2: key.publicKey,
                field1: 'Profile',
                limit: 100
              }, function (txs) {
                return _this5.buildProfileFromTransactions(txs);
              }, 'localhost'));
          }
        }, _callee10, this);
      }));
      function fetchProfileFromArchive(_x0) {
        return _fetchProfileFromArchive.apply(this, arguments);
      }
      return fetchProfileFromArchive;
    }()
    /**
     * Delete previously indexed local Profile txs (snapshot and/or legacy per-field).
     */
  }, {
    key: "deleteIndexedProfileTransactions",
    value: function () {
      var _deleteIndexedProfileTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var profile_index,
          sigs,
          _i7,
          _Object$keys4,
          field,
          value,
          _iterator2,
          _step2,
          sig,
          _args11 = arguments,
          _t4;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              profile_index = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
              sigs = new Set();
              if (profile_index.tx_sig && typeof profile_index.tx_sig === 'string') {
                sigs.add(profile_index.tx_sig);
              }
              _i7 = 0, _Object$keys4 = Object.keys(profile_index);
            case 1:
              if (!(_i7 < _Object$keys4.length)) {
                _context11.n = 4;
                break;
              }
              field = _Object$keys4[_i7];
              if (!PROFILE_INDEX_META_KEYS.has(field)) {
                _context11.n = 2;
                break;
              }
              return _context11.a(3, 3);
            case 2:
              value = profile_index[field];
              if (typeof value === 'string' && value) {
                sigs.add(value);
              }
            case 3:
              _i7++;
              _context11.n = 1;
              break;
            case 4:
              _iterator2 = _createForOfIteratorHelper(sigs);
              _context11.p = 5;
              _iterator2.s();
            case 6:
              if ((_step2 = _iterator2.n()).done) {
                _context11.n = 8;
                break;
              }
              sig = _step2.value;
              _context11.n = 7;
              return this.app.storage.deleteTransaction(sig, '', 'localhost');
            case 7:
              _context11.n = 6;
              break;
            case 8:
              _context11.n = 10;
              break;
            case 9:
              _context11.p = 9;
              _t4 = _context11.v;
              _iterator2.e(_t4);
            case 10:
              _context11.p = 10;
              _iterator2.f();
              return _context11.f(10);
            case 11:
              return _context11.a(2);
          }
        }, _callee11, this, [[5, 9, 10, 11]]);
      }));
      function deleteIndexedProfileTransactions() {
        return _deleteIndexedProfileTransactions.apply(this, arguments);
      }
      return deleteIndexedProfileTransactions;
    }()
  }, {
    key: "saveProfileTransaction",
    value: function () {
      var _saveProfileTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(tx) {
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return this.app.storage.saveTransaction(tx, {
                field1: 'Profile',
                preserve: 1
              }, 'localhost');
            case 1:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function saveProfileTransaction(_x1) {
        return _saveProfileTransaction.apply(this, arguments);
      }
      return saveProfileTransaction;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var mod_self = this;
      expressapp.get('/' + encodeURI(this.returnSlug()), /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(req, res) {
          var reqBaseURL, updatedSocial, html;
          return _regenerator().w(function (_context13) {
            while (1) switch (_context13.n) {
              case 0:
                reqBaseURL = req.protocol + '://' + req.headers.host + '/';
                updatedSocial = Object.assign({}, mod_self.social);
                updatedSocial.url = reqBaseURL + encodeURI(mod_self.returnSlug());
                html = pageHome(app, mod_self, app.build_number, updatedSocial);
                if (res.finished) {
                  _context13.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context13.a(2, res.send(html));
              case 1:
                return _context13.a(2);
            }
          }, _callee13);
        }));
        return function (_x10, _x11) {
          return _ref4.apply(this, arguments);
        };
      }());
      expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
    }
  }]);
}(ModTemplate);
module.exports = Profile;